import React from 'react';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import RadioButtonCheckedRoundedIcon from '@material-ui/icons/RadioButtonCheckedRounded';
import RadioButtonUncheckedRoundedIcon from '@material-ui/icons/RadioButtonUncheckedRounded';

import { IMetaFormat } from '../../../../../store/admin/roundFormats/store';

interface IProps {
  metaFormatToUpdate: IMetaFormat;
  onSaveMetaFormat: (format: IMetaFormat) => void;
}

export const HowManyStrikesBeforeEliminated = (props: IProps) => {
  const { metaFormatToUpdate, onSaveMetaFormat } = props;

  const onChange = ({ target: { value: strikes } }: any) =>
    onSaveMetaFormat({ ...metaFormatToUpdate, strikes: Number(strikes) });

  return (
    <div>
      <span className="format-label players-per-team">
        HOW MANY STRIKES BEFORE A PLAYER IS ELIMINATED:
      </span>

      {[1, 2, 3, 4].map((index: number) => (
        <FormControlLabel
          key={`formcontrol-how-many-strikes-${index}`}
          className="round-subformat-checkbox override"
          classes={{ label: 'label' }}
          control={
            <Checkbox
              className="check-considered-flight"
              id={`checkbox-how-many-strikes-${index}`}
              checked={
                metaFormatToUpdate.strikes === index || (!metaFormatToUpdate.strikes && index === 1)
              }
              onChange={onChange}
              icon={<RadioButtonUncheckedRoundedIcon fontSize="large" />}
              checkedIcon={<RadioButtonCheckedRoundedIcon fontSize="large" />}
              value={String(index)}
              color="primary"
            />
          }
          label={index}
        />
      ))}
    </div>
  );
};
